import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { map, take } from "rxjs";
import { SharedService } from "src/app/features/http-services/shared.service";
import { StorageService } from "src/app/features/http-services/storage.service";

@Component({
  selector: "app-switch-tab-modal",
  templateUrl: "./switch-tab-modal.component.html",
  styleUrls: ["./switch-tab-modal.component.scss"],
})
export class SwitchTabModalComponent implements OnInit {
  isSalesPerson: boolean = false;
  onAction: Function = () => {};

  constructor(
    private modalService: BsModalService,
    private storageService: StorageService,
    private sharedService: SharedService,
    private router: Router,
  ) {}

  handleAction() {
    this.onAction();
    this.modalService.hide("switchtab");
    if(this.isSalesPerson){
      this.sharedService.triggerHeaderUpdate()
      this.storageService.removeItem("cart");
      this.sharedService.setMiniCartValue({ code: null, totalItems: 0 });
      this.router.navigate(['/salesman-dashboard']);
    }
  }

  ngOnInit(): void {
    this.storageService
      .getItem("customer-details")
      .pipe(
        take(1),
        map((customerDetails) => {
          this.isSalesPerson =
            !!customerDetails?.isSalesPerson ||
            !!customerDetails?.isSalesOpsUser;
        })
      )
      .subscribe();
  }
}
